<template>
	<div>
		<a-form :form="form">
			<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="行业标签">
				<a-input v-decorator="['area', { rules: [{ required: true, message: '请输入商会行业' }] }]" placeholder="请输入商会行业标签" />
				<a-button
					type="primary"
					@click="addArae()"
				>
					添加行业
				</a-button>
			</a-form-item>
		</a-form>
		<div v-for="(item,index) in areaArray" :key="index" style="float: left; margin-left: 20px;margin-top: 10px;">
			<span >
				<a-card hoverable size="small" title="行业" style="width: 300px">
					<a href="#" slot="extra">删除</a>
					<h2 style="color: red">{{item.name}}</h2>
				</a-card>
			</span>
		</div>
		
		 <a-list item-layout="horizontal" :data-source="data">
		    <a-list-item slot="renderItem" slot-scope="item, index">
		      <a-list-item-meta
		        description="Ant Design, a design language for background applications, is refined by Ant UED Team"
		      >
		        <a slot="title" href="https://www.antdv.com/">{{ item.title }}</a>
		        <a-avatar
		          slot="avatar"
		          src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
		        />
		      </a-list-item-meta>
		    </a-list-item>
		  </a-list>
		
	</div>
</template>
<script>
	const data = [
	  {
	    title: 'Ant Design Title 1',
	  },
	  {
	    title: 'Ant Design Title 2',
	  },
	  {
	    title: 'Ant Design Title 3',
	  },
	  {
	    title: 'Ant Design Title 4',
	  },
	];
export default {
	data() {
		return {
			visible: true,
			form: this.$form.createForm(this, { name: 'dynamic_rule' }),
			areaArray:[{
				"id": 1,
				"name": "客服"
			},
			{
				"id": 2,
				"name": "包装"
			},
			{
				"id": 2,
				"name": "程序员"
			}],
			data
		};
	},
	methods:{
		addArae(){
			if(this.form.getFieldsValue().area){
				var obj = {};
				var id = this.areaArray[this.areaArray.length-1].id ++;
				obj.id = id;
				obj.name = this.form.getFieldsValue().area;
				this.areaArray.push(obj)
			}else{
				this.$message.error('请输入商会行业！');
			}
			
		}
	}
};
</script>
